import { ContainerType } from './ContainerType'
import Container from './Container'
import { playerDims } from '../utils'
import Logger from '../Log'

const Log = Logger.for('HeadlinerContainer')

export default class SimpleContainer extends Container {
  constructor () {
    super(ContainerType.HEADLINER, true)
  }

  style (bid, slot, media) {
    const container = slot.container()
    const node = slot.node()

    let dims = playerDims(media, bid)
    if (dims[0] === 1) {
      if (media.video.playerSize) {
        dims = media.video.playerSize
      } else {
        dims = media.banner.sizes[0]
      }
    }
    const gap = dims[1] + 20

    const oldMargin = document.body.style['margin-top']

    document.body.style.transition = '400ms ease'
    document.body.style['margin-top'] = gap + 'px'

    container.style['z-index'] = 1000
    container.style.padding = '10px 0px 10px 0px'
    container.style.top = '0px'
    container.style.left = '-50%'
    container.style.position = 'fixed'
    container.style.width = '200%'
    container.style.margin = '0px'
    container.style['background-color'] = 'black'
    container.style.height = gap + 'px'

    container.style.display = 'flex'
    container.style['justify-content'] = 'center'

    node.style.position = 'absolute'
    node.style.height = '100%'
    node.style.transition = '300ms ease'

    window.addEventListener('scroll', () => {
      container.style.transition = '500ms'
      container.style['transform-origin'] = 'top center'
      container.style.transform = 'scale(0.5) translateY(-2%)'
      document.body.style['margin-top'] = (gap / 2) + 'px'
    }, { once: true })

    slot.onDestroy(() => {
      Log.info('Cleaning up headliner container')
      document.body.style.transition = '400ms ease'
      document.body.style['margin-top'] = oldMargin
    })
  }
}
